import { ChangeDetectorRef, Component, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  CodeConversionMstDto,
  Sgke152aRequest
} from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { CodeConversionMstService } from '../../../../../../sg-base/sg-base-shared/services/codeConversionMst.service';
import { UsedSGKE152AService } from '../../services/used-sgke152a.service';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke150d',
  templateUrl: './sgke150d.component.html',
  styleUrl: './sgke150d.component.scss',
})
export class Sgke150dComponent implements OnInit, OnDestroy {

  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  /** 会社コード */
  static S900021: string = 'S900021';
  /** 入金地区コード */
  static S300561: string = 'S300561';

  /** 購読を停止するためのSubject */
  private onDestroy$ = new Subject();

  /** コード変換マスタマップ */
  codeMap: Map<string, CodeConversionMstDto[]> = null;

  /** 入金報告表出力APIリクエスト情報 FormGroup */
  outputCndtFormGroup: UntypedFormGroup;

  /**
   * コンストラクタ
   * @param {UntypedFormBuilder} fb
   * @param {CodeConversionMstService} codeConversionMstService
   * @param {UsedSGKE152AService} downloadService
   * @param {ResponseMsgUtils} responseMsgUtils
   * @param {ChangeDetectorRef} cd 
   * @memberof Sgke150dComponent
   */
  constructor(
    private fb: UntypedFormBuilder,
    private codeConversionMstService: CodeConversionMstService,
    public downloadService: UsedSGKE152AService,
    private responseMsgUtils: ResponseMsgUtils,
    private cd: ChangeDetectorRef,
  ) { }

  /**
   * 初期処理
   * @returns {void}
   * @memberof Sgke150dComponent
   */
  ngOnInit(): void {
    // 検索条件Formを初期化
    this.outputCndtFormGroup = this.fb.group({
      requestCommon: new UntypedFormGroup({}),
    });

    const dispItemIdList = [
      Sgke150dComponent.S900021,
      Sgke150dComponent.S300561,
    ];

    //コード値の取得
    this.codeConversionMstService.getCodeConversionMst(dispItemIdList)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(codeMap => {
        this.codeMap = codeMap;
      });

  }

  /**
   * 購読解除
   * @returns {void}
   * @memberof Sgke150dComponent
   */
  ngOnDestroy(): void {
    //購読を停止する処理
    this.onDestroy$.next();
  }

  /**
   * 出力ボタン押下処理
   * @returns {void}
   * @memberof Sgke150dComponent
   */
  public download(): void {

    // メッセージクリア
    this.clearErrorMsg();

    const request: Sgke152aRequest = this.outputCndtFormGroup.getRawValue() as Sgke152aRequest;

    // SGKE404A呼び出し
    this.downloadService.doSgke152a(request).pipe(takeUntil(this.onDestroy$)).subscribe(
      response => {
        if (response) {
          // メッセージを表示
          this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(response?.responseCommon?.errors, this.errorMessageModelArray);
        }
      },
      error => {
      }
    );
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @returns {void}
   * @memberof Sgke150dComponent
   */
  private clearErrorMsg(): void {
    this.errorMessageModelArray = new Array<SgAriaMessage>();
    this.cd.detectChanges();
  }

}
